import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "../components/Layout.vue";
import Home from "../views/home/Home.vue";
import Index from "../views/mch/Index.vue";
import InputPieceSh from "@/views/mch/InputPieceSh.vue";
import Login from "@/views/login/login.vue";

Vue.use(VueRouter)

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/',
    name: 'index',
    component: Layout,
    redirect: '/agent/list',
    meta: {
      title: '工作台',
      hidden: true,
      raking: 1,
      auth: ['A','M'],
      icon: 'iconfont el-icon-luzhang'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '工作台',
        },
        component: () => import('@/views/home/Home.vue')
      },
      {
        path: 'pieceManager',
        name: 'pieceManager',
        meta: {
          title: '审核管理',
        },
        component: () => import('@/views/mch/InputPieceSh.vue')
      },
    ]
  },
  {
    path: '/alipay',
    name: 'alipay',
    meta: {
      title: '支付页面',
      hidden: true
    },
    component: () => import('@/views/pay/alipay.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      hidden: true
    },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: Layout,
    meta: {
      title: '订单管理',
      raking: 7,
      auth: [],
      icon: 'iconfont el-icon-ziyuan-tuceng'
    },
    children: [
      {
        path: 'list',
        name: 'orderList',
        meta: {
          auth: [],
          title: '订单列表',
          isNew: true,
          upTitle: '订单列表',
        },
        component: () => import('@/views/order/List.vue')
      }
    ]
  },
  {
    path: '/incom',
    name: 'black',
    component: Layout,
    meta: {
      title: '进件管理',
      raking: 3,
      auth: [],
      icon: 'iconfont el-icon-yulan'
    },
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          auth: [],
          title: '进件列表',
          isNew: true,
          upTitle: '进件管理',
        },
        component: () => import('@/views/fwy-incom/List.vue')
      }
    ]
  },
  {
    path: '/account',
    name: 'account',
    component: Layout,
    meta: {
      title: '账户管理',
      auth: [],
      raking: 6,
      icon: 'iconfont el-icon-qianbao'
    },
    children: [
      {
        path: 'cz',
        name: 'cz',
        meta: {
          auth: [],
          title: '充值',
          upTitle: '账户管理',
        },
        component: () => import('@/views/account/cz.vue')
      },
      {
        path: 'purse',
        name: 'purse',
        meta: {
          auth: [],
          title: '资金操作记录',
          upTitle: '账户管理',
        },
        component: () => import('@/views/account/Purse.vue')
      },
      {
        path: 'zbmx',
        name: 'zbmx',
        meta: {
          auth: [],
          title: '资金账变明细',
          upTitle: '账户管理',
        },
        component: () => import('@/views/account/zbmx.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

import store from '@/store'
router.beforeEach((to, from, next) => {
  if (to.path === '/ts' || to.path === '/alit' || to.path === '/alipc' || to.path === '/test2' || to.path === '/test' || to.path === '/alipaysuccess' || to.path === '/login' || to.path === '/pay' || to.path === '/authPay' || to.path === '/h5-piece' || to.path === '/wxPay' || to.path === '/rwmPay' || to.path.startsWith('/alipay') || to.path === '/h5pay' || to.path === '/paySuccess') {
    next()
  }else{
    if (store.getters.token) {
      // let hidden = menus.filter(x => x.index === to.path)[0].hidden.indexOf(store.getters.userInfo.id.substring(0,1)) !== -1;
      // console.log(hidden,"-=----",to.path,store.getters.userInfo.id)
      // if (store.getters.userInfo.id.substring(0,1) == "M"){
      //     next("/order/list")
      // }else{
      next()
      // }
      // if (hidden) {
      //     next()
      // } else {
      //     next("/order/list")
      // }
    } else {
      next("/login")
    }
  }
  // }
})
export default router;
